import React, { Component } from "react";
import { Form, FormGroup } from "react-bootstrap";
import classnames from "classnames";
import { Link } from "react-router-dom";
import Input from "../../../../components/common/input/Input";
import Select2 from "../../../../components/common/select/Select2";
import Button from "../../../../components/common/button/Button";
import Checkbox from "../../../../components/common/checkbox/Checkbox";
import styles from "./SignUp.scss";
import { MEMBER_SIGNUP_FORM } from "../../../../actions/user.actions";
import {
  required,
  minLength,
  email,
  checkboxChecked
} from "../../../../utils/forms/validators";
import { Field, reduxForm } from "redux-form";
import ReactPixel from "react-facebook-pixel";

export const emailValidation = msg => email(msg);
export const minLengthValidation = (min, msg) => minLength(min, msg);
export const checkboxCheckedValidation = msg => checkboxChecked(msg);

export const emailVal = emailValidation("Please enter a valid email address.");
export const password = minLengthValidation(
  8,
  "Password must be at least 8 characters."
);
export const checkbox = checkboxCheckedValidation(
  "You must agree to terms of use."
);

const REFERRAL_FRIEND = 54;
const REFERRAL_TSS = 55;
// const REFERRAL_WEB = 56;
// const REFERRAL_PRESS = 57;
// const REFERRAL_LINKEDIN = 58;
const REFERRAL_SOCIAL = 59;
const REFERRAL_OTHER = 60;

class SignUp extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showSelectInput: false,
      referralEdited: false,
      howHearPlaceholder: ""
    };
    this.handleSelect = this.handleSelect.bind(this);
  }

  componentDidMount() {
    ReactPixel.init("727220614296789");
    ReactPixel.track("BeginSignUp");
  }

  getPlaceholderByValue(value) {
    switch (value) {
      case REFERRAL_FRIEND:
        return "Friend's Name";
      case REFERRAL_TSS:
        return "Referrer's Name";
      case REFERRAL_SOCIAL:
        return "Which social-media channel?";
      case REFERRAL_OTHER:
        return "Where'd you hear about us?";
      default:
        return "How'd you hear about us?";
    }
  }

  handleSelect(value) {
    const showExtra =
      value == REFERRAL_FRIEND ||
      value == REFERRAL_TSS ||
      value == REFERRAL_SOCIAL ||
      value == REFERRAL_OTHER;

    this.props.change("referral_value", "");
    this.props.untouch("referral_value");

    this.setState({
      showSelectInput: showExtra,
      howHearPlaceholder: this.getPlaceholderByValue(value),
      referralEdited: true
    });
  }

  render() {
    const { submitting, valid } = this.props;

    const referralsPlaceholder = this.state.referralEdited
      ? null
      : "How'd you hear about us?";

    return (
      <section>
        <section className={styles.memberSignUp}>
          <div className={styles.content}>
            <h2 className={styles.title}>Create Your Member Account</h2>

            <Form onSubmit={this.props.handleSubmit}>
              <div className={classnames(styles.form, styles.boxTop)}>
                <div className={styles.subtitle}>
                  <span>Looking for a consultant?</span>
                  <span>
                    {" "}
                    Go to <Link to="/company/sign-up">Company signup</Link>
                    &nbsp;instead.
                  </span>
                </div>

                <FormGroup>
                  <Field
                    name="email"
                    type="text"
                    placeholder="Email Address"
                    component={Input}
                    validate={[required, emailVal]}
                  />

                  <Field
                    name="password"
                    type="password"
                    placeholder="Account Password"
                    component={Input}
                    validate={[required, password]}
                    showPasswordIcon
                    autoComplete="off"
                  />

                  <Field
                    name="referral_type"
                    type="select"
                    placeholder={referralsPlaceholder}
                    component={Select2}
                    onSelectChange={this.handleSelect}
                    options={this.props.referrals}
                  />

                  {this.state.showSelectInput && (
                    <Field
                      name="referral_value"
                      type="text"
                      placeholder={this.state.howHearPlaceholder}
                      component={Input}
                      validate={[required]}
                    />
                  )}
                </FormGroup>

                <div className={styles.divider} />

                <label className={styles.termsCheckbox}>
                  <Field name="terms" component={Checkbox} signUp={true} />
                  <span className={styles.checkboxText}>
                    I agree to The Second Shift{" "}
                    <a
                      href="https://www.thesecondshift.com/tos"
                      target="_blank"
                    >
                      Terms of Service
                    </a>
                    &nbsp;and{" "}
                    <a
                      href="https://www.thesecondshift.com/privacy"
                      target="_blank"
                    >
                      Privacy Policy.
                    </a>
                  </span>
                </label>

                <p className={styles.error}>{this.props.checkboxError}</p>

                <Button
                  isPrimary
                  type="submit"
                  size={"large"}
                  label="Create Member Account"
                  isDisabled={!valid || submitting}
                />
              </div>
            </Form>
          </div>
        </section>
      </section>
    );
  }
}

export default (SignUp = reduxForm({
  form: MEMBER_SIGNUP_FORM
})(SignUp));



// WEBPACK FOOTER //
// ./src/routes/candidate/signUp/components/SignUp.js